import { createV2UsersMeOffHoursSchedulesSelector } from "./createV2USersMeScheduleSelector";
import { RootState } from "../../../store";
export const duplicateWorkflowLoadingSelector = (
  state: RootState,
  id: string,
) => {
  return createV2UsersMeOffHoursSchedulesSelector(id)(state)?.isLoading;
};
